import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/5_card_back_blue_pattern/5_card_back_blue_pattern"
 * Contains 1 texture(s)
 */
export class CardsBacks5CardBackBluePatternAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/5_card_back_blue_pattern/5_card_back_blue_pattern';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '5_blue_pattern.png'
    ] as const;
}
